


import React, { memo } from 'react';
import { Link } from '../../ui-kit';

const HELP_URL = 'https://help.shootsta.com/en';

function openHelpPage() {
  window.open(HELP_URL, '_blank');
}

function HelpCenterButton() {
  return <Link button onClick={openHelpPage}>Help Center</Link>;
}

export default memo(HelpCenterButton);